// Utility functions for loading CMS content
// Now loads real CMS content from generated JSON files

// Dynamic imports for CMS data
let projectsData = null;
let testimonialsData = null;
let settingsData = null;
let blogData = null;

// Lazy loading functions
const loadProjects = async () => {
  if (!projectsData) {
    try {
      projectsData = await import('../data/cms/projects.json').then(module => module.default);
    } catch (error) {
      console.error('CMS projects data not found:', error);
      projectsData = [];
    }
  }
  return projectsData;
};

const loadTestimonials = async () => {
  if (!testimonialsData) {
    try {
      testimonialsData = await import('../data/cms/testimonials.json').then(module => module.default);
    } catch (error) {
      console.warn('CMS testimonials data not found, using fallback data');
      // Fallback data
      testimonialsData = [
        {
          id: 1,
          name: 'Selina',
          image: 'https://images.unsplash.com/photo-1494790108755-2616b612b47c?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
          text: 'Nach langem Suchen habe ich endlich Jarek gefunden. Die Auswahl seiner Arbeiten ist sehr vielfältig und von hoher Qualität. Der gesamte Prozess war sehr einfach und mein Badezimmer sieht eleganter und moderner aus. Sehr empfehlenswert!',
          rating: 5,
          project: 'Badezimmer-Renovierung',
          featured: true
        },
        {
          id: 2,
          name: 'David',
          image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
          text: 'Jarek hat unsere Küche komplett neu gefliest. Perfekte Arbeit, pünktlich und sauber. Die Fliesen sehen fantastisch aus und die Qualität ist erstklassig. Wir sind sehr zufrieden!',
          rating: 5,
          project: 'Küchen-Renovierung',
          featured: true
        }
      ];
    }
  }
  return testimonialsData;
};

const loadSettings = async () => {
  if (!settingsData) {
    try {
      settingsData = await import('../data/cms/settings.json').then(module => module.default);
    } catch (error) {
      console.warn('CMS settings data not found, using fallback data');
      // Fallback data
      settingsData = {
        general: {
          siteName: 'Fliesen Jarek',
          title: 'Fliesen Jarek - Professionelle Fliesenarbeiten',
          description: 'Ihr erfahrener Fliesenleger aus Cuxhaven. Über 15 Jahre Erfahrung in Badezimmer-Renovierungen, Küchen und Mosaik-Arbeiten.',
          phone: '0151-54610847',
          email: 'jarek.j79@web.de',
          whatsapp: '015154610847',
          address: {
            street: 'Werner-Kammann-Str. 18',
            city: 'Cuxhaven',
            zip: '27472',
            country: 'Deutschland',
            full: 'Werner-Kammann-Str. 18\n27472 Cuxhaven'
          },
          baseUrl: 'https://fliesen-jarek.de',
          logo: '/logo.png'
        },
        about: {
          title: 'Über mich',
          image: '/images/Jarek/image.jpg',
          experience: 15,
          projects_completed: 500,
          satisfaction: 98,
          body: '<h2>Jarek Jozwiak - Ihr Fliesenleger</h2>'
        },
        hero: {
          title: 'Professionelle Fliesenarbeiten',
          subtitle: 'Mit Präzision & Leidenschaft',
          description: 'Über 15 Jahre Erfahrung in der Fliesenverlegung. Von Badezimmer-Renovierungen bis zu Designer-Küchen - verwandle ich Ihre Räume mit höchster Handwerksqualität und Liebe zum Detail.',
          cta_text: 'Kostenloses Angebot',
          background_image: '/images/projekte/neuneuneu/WhatsApp Image 2025-06-29 at 10.50.35 (4).jpeg'
        }
      };
    }
  }
  return settingsData;
};

const loadBlog = async () => {
  if (!blogData) {
    try {
      blogData = await import('../data/cms/blog.json').then(module => module.default);
    } catch (error) {
      console.warn('CMS blog data not found, using empty array');
      blogData = [];
    }
  }
  return blogData;
};

// Synchronous versions for compatibility (these will be loaded by React components)
// We need to preload the data or use React hooks

// For synchronous usage, we'll try to use the preloaded data
export const getProjects = () => {
  if (projectsData) {
    return projectsData;
  }
  
  // If not loaded yet, try to load synchronously from CMS data
  try {
    const cmsProjects = require('../data/cms/projects.json');
    return cmsProjects;
  } catch (error) {
    console.warn('No CMS project data available');
    return [];
  }
};

export const getProjectBySlug = (slug) => {
  const projects = getProjects();
  return projects.find(project => project.slug === slug);
};

export const getTestimonials = () => {
  if (testimonialsData) {
    return testimonialsData;
  }
  
  // Fallback testimonials
  return [
    {
      id: 1,
      name: 'Selina',
      image: 'https://images.unsplash.com/photo-1494790108755-2616b612b47c?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      text: 'Nach langem Suchen habe ich endlich Jarek gefunden. Die Auswahl seiner Arbeiten ist sehr vielfältig und von hoher Qualität. Der gesamte Prozess war sehr einfach und mein Badezimmer sieht eleganter und moderner aus. Sehr empfehlenswert!',
      rating: 5,
      project: 'Badezimmer-Renovierung',
      featured: true
    },
    {
      id: 2,
      name: 'David',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      text: 'Jarek hat unsere Küche komplett neu gefliest. Perfekte Arbeit, pünktlich und sauber. Die Fliesen sehen fantastisch aus und die Qualität ist erstklassig. Wir sind sehr zufrieden!',
      rating: 5,
      project: 'Küchen-Renovierung',
      featured: true
    },
    {
      id: 3,
      name: 'Jennifer',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      text: 'Professioneller Service von Anfang bis Ende. Jarek berät sehr gut bei der Fliesenauswahl und arbeitet präzise. Unser neues Badezimmer ist ein Traum geworden!',
      rating: 5,
      project: 'Badezimmer-Design'
    },
    {
      id: 4,
      name: 'Michael',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      text: 'Schnelle Terminvergabe, faire Preise und exzellente Handwerkskunst. Jarek hat unser Gäste-WC renoviert und wir könnten nicht glücklicher sein mit dem Ergebnis.',
      rating: 5,
      project: 'Gäste-WC'
    },
    {
      id: 5,
      name: 'Sarah',
      image: 'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      text: 'Zuverlässig, kompetent und freundlich. Die Fliesenarbeiten in unserem Wohnzimmer wurden perfekt ausgeführt. Jarek ist definitiv der beste Fliesenleger in Cuxhaven!',
      rating: 5,
      project: 'Wohnbereich'
    }
  ];
};

export const getBlogPosts = () => {
  if (blogData) {
    return blogData;
  }
  return [];
};

export const getSiteSettings = () => {
  if (settingsData && settingsData.general) {
    // Merge general settings with computed properties for backward compatibility
    return {
      ...settingsData.general,
      // Legacy compatibility properties
      siteName: settingsData.general.siteName,
      baseUrl: settingsData.general.baseUrl,
      // Address handling for schema.org
      address: {
        ...settingsData.general.address,
        geo: {
          latitude: 53.8682, // Cuxhaven coordinates
          longitude: 8.6951
        }
      },
      // Opening hours for schema.org
      openingHours: [
        {
          '@type': 'OpeningHoursSpecification',
          'dayOfWeek': [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday'
          ],
          'opens': '08:00',
          'closes': '17:00'
        }
      ]
    };
  }
  
  // Fallback settings
  return {
    siteName: 'Fliesen Jarek',
    title: 'Fliesen Jarek - Professionelle Fliesenarbeiten',
    description: 'Ihr erfahrener Fliesenleger aus Cuxhaven. Über 15 Jahre Erfahrung in Badezimmer-Renovierungen, Küchen und Mosaik-Arbeiten.',
    phone: '0151-54610847',
    email: 'jarek.j79@web.de',
    whatsapp: '015154610847',
    address: {
      street: 'Werner-Kammann-Str. 18',
      city: 'Cuxhaven',
      zip: '27472',
      country: 'Deutschland',
      full: 'Werner-Kammann-Str. 18\n27472 Cuxhaven',
      geo: {
        latitude: 53.8682,
        longitude: 8.6951
      }
    },
    baseUrl: 'https://fliesen-jarek.de',
    logo: '/logo.png'
  };
};

export const getAboutContent = () => {
  if (settingsData && settingsData.about) {
    return settingsData.about;
  }
  
  // Fallback about content
  return {
    title: 'Über mich',
    image: '/images/Jarek/image.jpg',
    experience: 15,
    projects_completed: 500,
    satisfaction: 98,
    body: `<h2>Jarek Jozwiak - Ihr Fliesenleger</h2>
           <p>Mein Name ist <strong>Jarek Jozwiak</strong> und ich bin leidenschaftlicher Fliesenleger aus Cuxhaven. Seit über 15 Jahren verwandle ich Räume mit hochwertigen Fliesen und präziser Handwerkskunst.</p>
           <p>Jedes Projekt ist für mich eine neue Herausforderung, bei der ich höchste Qualität und termingerechte Ausführung garantiere. Von der ersten Beratung bis zur finalen Reinigung stehe ich Ihnen persönlich zur Seite.</p>`
  };
};

export const getHeroContent = () => {
  if (settingsData && settingsData.hero) {
    return settingsData.hero;
  }
  
  // Fallback hero content
  return {
    title: 'Professionelle Fliesenarbeiten',
    subtitle: 'Mit Präzision & Leidenschaft',
    description: 'Über 15 Jahre Erfahrung in der Fliesenverlegung. Von Badezimmer-Renovierungen bis zu Designer-Küchen - verwandle ich Ihre Räume mit höchster Handwerksqualität und Liebe zum Detail.',
    cta_text: 'Kostenloses Angebot',
    background_image: '/images/projekte/neuneuneu/WhatsApp Image 2025-06-29 at 10.50.35 (4).jpeg'
  };
}; 

// Initialize data loading
const initializeCMSData = async () => {
  try {
    const [projects, testimonials, settings, blog] = await Promise.all([
      loadProjects(),
      loadTestimonials(),
      loadSettings(),
      loadBlog()
    ]);
    
    projectsData = projects;
    testimonialsData = testimonials;
    settingsData = settings;
    blogData = blog;
    
    console.log('✅ CMS data loaded successfully');
  } catch (error) {
    console.warn('⚠️ Some CMS data could not be loaded:', error);
  }
};

// Auto-initialize when module is imported
if (typeof window !== 'undefined') {
  initializeCMSData();
}

// Export async functions for components that can use them
export { loadProjects, loadTestimonials, loadSettings, loadBlog, initializeCMSData }; 
